module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('DateTime', {
    attrs: {
      "date-only": true,
      "label": _vm.element.title,
      "disabled": _vm.element.disabled,
      "hide-details": true,
      "single-line": false
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-459bbcbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/controls/DateControl.vue
// module id = 2528
// module chunks = 1